import React from 'react';
import PropTypes from 'prop-types';
import {Button, Input, Modal, Pagination, Table, Radio} from 'antd';
import {message} from "../sysManagement/utils/sysManagementUtils";
import {Scrollbars} from "react-custom-scrollbars";
import BaseComponent from "../../base/BaseComponent";
import $ from "jquery";
import "../mediaManage/pms/MediaAdminister.css";

let height = window.innerHeight - 96;

class StationGroupManagement extends BaseComponent {
    static defaultProps = {};
    static propTypes = {};

    constructor(props) {
        super(props);
        this.state = {
            columns: [
                {
                    title: '站群地址',
                    dataIndex: 'webSiteUrl',
                    key: 'webSiteUrl',
                    ellipsis: true,
                },
                {
                    title: '客户端ID',
                    dataIndex: 'cid',
                    key: 'cid',
                    ellipsis: true,
                },
                {
                    title: '客户端账号',
                    dataIndex: 'account',
                    key: 'account',
                    ellipsis: true,
                },
                // {
                //     title: ' 客户端密码',
                //     dataIndex: 'password',
                //     key: 'password',
                //     align: 'center',
                //     ellipsis: true,
                // },
                {
                    title: ' 站群版本',
                    dataIndex: 'version',
                    key: 'version',
                    ellipsis: true,
                    render: (text, record, index) => {
                        let showText = "990之前版本";
                        if (record.version === "990") {
                            showText = "990及之后版本";
                        }
                        return (
                            <div>{showText}</div>
                        )
                    }
                },
                {
                    title: '操作',
                    key: 'operate',
                    render: (text, record, index) => {
                        return (
                            <div style={{display: "flex", alignItems: "center"}}>
                                {/*<div style={{marginRight: "5px"}}>*/}
                                {/*    /!*查看  把record传递给params 然后打开弹窗  onlyRead*!/*/}
                                {/*    <Button type="primary" onClick={() => {*/}
                                {/*        this.view("查看", record)*/}
                                {/*    }}>查看</Button>*/}
                                {/*</div>*/}
                                <div style={{marginRight: "16px"}}>
                                    {/*修改  把record传递给params 然后打开弹窗*/}
                                    <span style={{cursor: "pointer"}} onClick={() => {
                                        this.view("修改", record)
                                    }}>修改</span>
                                </div>
                                <div>
                                    {/*删除 取record里面的ID,然后调接口删除*/}
                                    <span style={{color: "red",cursor: "pointer"}} onClick={() => {
                                        this.delete(record)
                                    }}>删除</span>
                                </div>
                            </div>
                        )
                    }
                },
            ],//表格头
            dataSource: [],//表格内容
            params: {
                // 管理机访问域名
                webSiteUrl: '',
                // 客户端ID
                cid: '',
                // 客户端账号
                account: '',
                // 客户端密码
                password: '',
                // 站群版本
                version: '990',
                keywords: '',//搜索字段
                size: 10,//每页条数
                page: 1,//当前第几页

            },
            total: '',//列表总数
            oldParams: {},//表格旧的数据
            visible: false,//弹框是否显示
            modalTitle: '新增',//弹框标题
            onlyRead: false,//是否是只读
        }
    }

    componentDidMount() {
        this.getData();
    }

    //修改
    view = (title, record) => {
        this.state.modalTitle = title;
        this.state.visible = true;
        let params = {...this.state.params, ...record};
        this.state.params = {...params};
        this.state.oldParams = {...params};
        this.state.onlyRead = title == "查看" ? true : false;
        this.setState({});
    }

    //渲染列表
    getData() {
        let {params} = this.state;
        this.request({
            url: '/cm-sites-pms/vsbManage/list',
            method: "get",
            body: params,
            callBack: (res) => {
                let dataSource = [];
                let total = 0;
                if(res && res.data && res.data.length){
                    total= res.count;
                    dataSource = res.data;
                }
                this.setState({
                    dataSource,
                    total
                }, () => {
                    $('.ant-pagination-options-quick-jumper').find("input").val("");
                })
            },
            errorCallBack: () => {
            },
        })
    }

    //删除
    delete(item) {
        this.request({
            url: '/cm-sites-pms/vsbManage/deleteById',
            // contentType: "json",   //不需要contentType,formData格式
            method: "post",
            body: {"id": item.id},
            callBack: (res) => {
                if (res) {
                    message.success("删除成功");
                } else {
                    message.error("删除失败！");
                }
                this.getData();
            },
            errorCallBack: (e) => {
                message.error(e)
            },
        })


    }

    //输入框
    onChange = (type, val) => {
        this.state.params[type] = val;
        this.setState({});
    };

    //分页器
    onSearch = (page, pageSize) => {
        this.state.params.page = page;
        this.state.params.size = pageSize;
        let {params} = this.state;
        this.request({
            url: '/cm-sites-pms/vsbManage/list',
            body: params,
            callBack: () => {
                this.getData();
            },
            errorCallBack: (e) => {
                message.error(e)
            },
        })
        this.setState({});
    }
    //params里面如果存在数据,就请求接口,将params发送给后端,后端返回数据,更新表格
    onOk = () => {
        let params = this.state.params;
        // 如果是查看直接关闭弹窗
        if (this.state.onlyRead) {
            this.setState({visible: false, onlyRead: false});
            return false
        }

        //校验
        if (!params.webSiteUrl || params.webSiteUrl.trim().length === 0) {
            message.error("请填写站群地址！");
            return;
        }
        let reg = new RegExp("^(http|https)://", "i");
        if (!reg.test(params.webSiteUrl)) {
            message.error("站群地址必须以http://或https://开头！");
            return;
        }

        if (!params.cid || params.cid.trim().length === 0) {
            message.error("请填写客户端ID！");
            return;
        }

        if (!params.account || params.account.trim().length === 0) {
            message.error("请填写客户端账号！");
            return;
        }

        if (!params.password || params.password.trim().length === 0) {
            message.error("请填写客户端密码！");
            return;
        }

        params.cid = params.cid && params.cid.trim();
        params.webSiteUrl = params.webSiteUrl && params.webSiteUrl.trim();

        // 如果是修改,校验是否做了修改
        if (this.state.modalTitle === "修改") {
            let notEdit = true;
            for (let i in this.state.oldParams) {
                if (this.state.oldParams[i] !== this.state.params[i]) {
                    notEdit = false;
                }
            }
            if (notEdit) {
                return message.error("你没有做任何修改！");
            }
            //修改
            this.request({
                url: "/cm-sites-pms/vsbManage/edit",
                contentType: "json",
                method: "post",
                body: params,
                callBack: (res) => {
                    if (res) {
                        message.success("修改成功");
                    } else {
                        message.error("修改失败！");
                    }
                    this.setState({visible: false})
                    this.getData();
                },
                errorCallBack: (e) => {
                    message.error("信息填写错误！")
                },
            })
        } else {
            this.request({
                url: "/cm-sites-pms/vsbManage/add",
                callBack: (res) => {
                    if (res) {
                        message.success("添加成功")
                    } else {
                        message.error("添加失败！")
                    }
                    this.setState({visible: false})
                    this.getData();
                },
                contentType: "json",
                method: "post",
                body: params,
                errorCallBack: (e) => {
                    message.error("信息填写错误！")
                },
            })
        }


    }

    //新增按钮
    renderScreeningConditions() {
        return (
            <div style={{
                display: 'flex',
                padding: "32px"
            }}>
                <div style={{marginRight: "20px"}}>
                    <Button
                        type="primary"
                        onClick={() => {
                            this.view("新增", {
                                webSiteUrl: '',
                                cid: '',
                                account: '',
                                password: '',
                                version: '990',
                                keywords: '',
                                size: 10,
                                page: 1,
                                createTime: "",
                                updateTime: "",
                                domain: ""
                            })
                        }}>新增</Button>
                </div>
                <div>
                    <Button
                        onClick={() => {
                            this.props.history.push("/view/sys/mediaAdminister/true");
                        }}>返回媒体管理</Button>
                </div>
                {/*<Search*/}
                {/*    style={{width:'300px',paddingLeft:'10px'}}*/}
                {/*    placeholder="请输入查询内容"*/}
                {/*    enterButton="查询"*/}
                {/*    size="middle"*/}
                {/*    onChange={value => {this.onSearch("str",value)}}*/}
                {/*    onSearch={this.getData}*/}
                {/*/>*/}
            </div>
        )
    }

    //表格
    renderContent() {
        let {columns, dataSource} = this.state;
        return (
            <div style={{backgroundColor: 'white',margin:"0 32px"}} id={"stationGroupManagement"}>
                <Scrollbars autoHeight autoHeightMax={height - 149}>
                    <Table columns={columns} dataSource={dataSource} pagination={false}/>
                </Scrollbars>
                <style>{`
                    #stationGroupManagement .ant-table-row:nth-child(2n) {
                        background-color: rgba(245, 248, 252, 1);
                    }
                `}</style>
            </div>
        )
    }

    //分页器
    renderFooter() {
        let {params, total} = this.state;
        return (
            <div style={{padding: "5px 0", display: "flex", justifyContent: "flex-end"}}>
                <Pagination
                    onChange={(page, pageSize) => {
                        this.onSearch(page, pageSize)
                    }}//页码改变回调
                    onShowSizeChange={(page, pageSize) => {
                        this.onSearch(page, pageSize)
                    }}//每页条数改变回调
                    total={total}
                    showTotal={total => `共${total}条`}
                    current={params.page}
                    pageSize={params.size}
                    showSizeChanger
                    showQuickJumper
                    hideOnSinglePage
                />
            </div>
        )
    }

    //弹窗
    renderBtnClickComponent() {
        let {visible, modalTitle, params, onlyRead} = this.state;
        return (
            <Modal
                visible={visible}
                title={modalTitle}
                maskClosable={false}
                onCancel={() => {
                    this.setState({visible: false})
                }}
                onOk={this.onOk}
                destroyOnClose={true}
            >
                <div>
                    <div style={{marginBottom: 20, display: "flex", alignItems: "center"}}>
                        <div style={{width: "20%", textAlign: "right"}}><span style={{color: 'red'}}>*</span>站群地址：</div>
                        <Input
                            className={'mediaAdministerContent'}
                            onChange={(e) => {
                                this.onChange("webSiteUrl", e.target.value)
                            }}
                            style={{width: "80%"}}
                            disabled={onlyRead}
                            placeholder={"请输入管理机访问域名"}
                            value={params['webSiteUrl']}
                        />
                    </div>
                    <div style={{marginBottom: 20, display: "flex", alignItems: "center"}}>
                        <div style={{width: "20%", textAlign: "right"}}><span
                            style={{color: 'red'}}>*</span>客户端ID：
                        </div>
                        <Input
                            className={'mediaAdministerContent'}
                            onChange={(e) => {
                                this.onChange("cid", e.target.value)
                            }}
                            disabled={onlyRead}
                            style={{width: "80%"}}
                            placeholder={"请输入客户端ID"}
                            value={params['cid']}
                        />
                    </div>
                    <div style={{marginBottom: 20, display: "flex", alignItems: "center"}}>
                        <div style={{width: "20%", textAlign: "right"}}><span
                            style={{color: 'red'}}>*</span>客户端账号：
                        </div>
                        <Input
                            className={'mediaAdministerContent'}
                            onChange={(e) => {
                                this.onChange("account", e.target.value)
                            }}
                            disabled={onlyRead}
                            style={{width: "80%"}}
                            placeholder={"请输入客户端账号"}
                            value={params['account']}
                        />
                    </div>
                    <div style={{marginBottom: 20, display: "flex", alignItems: "center"}} id={"password"}>
                        <div style={{width: "20%", textAlign: "right"}}><span
                            style={{color: 'red'}}>*</span>客户端密码：
                        </div>
                        <Input.Password
                            className={'mediaAdministerContent'}
                            onChange={(e) => {
                                this.onChange("password", e.target.value)
                            }}
                            disabled={onlyRead}
                            style={{width: "80%"}}
                            placeholder={"请输入客户端密码"}
                            value={params['password']}
                        />
                        <style>{`#password .ant-input{background-color: rgba(246, 248, 253, 0.86)}`}</style>
                    </div>
                    <div style={{display: "flex", alignItems: "center"}}>
                        <div style={{width: "20%", textAlign: "right"}}>站群版本：</div>
                        <Radio.Group onChange={(e) => {
                            this.onChange("version", e.target.value)
                        }} value={params['version']} style={{width: "80%"}}>
                            <Radio value={"982"}>990之前版本</Radio>
                            <Radio value={"990"}>990及之后版本</Radio>
                        </Radio.Group>
                    </div>
                </div>
            </Modal>
        )
    }

    render() {
        return (
            <div style={{margin: "15px", maxHeight: height,backgroundColor: "#fff",borderRadius:"5px"}}>
                {/*新增*/}
                {this.renderScreeningConditions()}
                {/*表格*/}
                {this.renderContent()}
                {/*分页器*/}
                {this.renderFooter()}
                {/*弹窗*/}
                {this.renderBtnClickComponent()}
            </div>
        );
    }
}

StationGroupManagement.propTypes = {};

export default StationGroupManagement;